import { createContext } from 'react';

export const ContainerWidthContext = createContext<number | null>(null);
